module.exports = "<p>\n  psa-licence-req-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-form/psa-licence-req-form.component.html
// module id = ./src/app/pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-form/psa-licence-req-form.component.html
// module chunks = main